<template>
  <Panel>
    <template #header>
      <span data-cy="heading">Campaign Settings</span>
    </template>

    <template #content>
      <validation-observer
        ref="formValidation"
        v-slot="{ handleSubmit }"
      >
        <b-form
          novalidate
          @submit.stop.prevent="handleSubmit(saveSettings)"
        >
          <BaseFormSelect
            id="buyer-campaign-settings__restrict-duplicates"
            v-model="restrictDuplicates"
            :horizontal="true"
            internal-platform-input
            :small="true"
            data-cy="select-restrict-duplicates"
            name="Restrict Duplicates"
            label="Restrict Duplicates"
            :options="restrictDuplicatesOptions"
            width="6"
            width-lg="3"
            required
          />

          <b-row no-gutters>
            <b-col
              cols="12"
              sm="6"
              offset-sm="3"
              lg="6"
              offset-lg="3"
            >
              <p
                class="text-muted small mb-3"
                data-cy="restrict-duplicates-helper-text"
              >
                Restrict duplicates for 30 days on previously connected calls. Campaigns can inherit
                this setting or set their own.
              </p>
            </b-col>
          </b-row>

          <BaseButtonLoader
            :horizontal="true"
            internal-platform-input
            variant="primary"
            :loading="loading"
            type="submit"
            data-cy="button-save-campaign-settings"
            :disabled="!hasChanges"
            @click="saveSettings"
          >
            Save
          </BaseButtonLoader>
        </b-form>
      </validation-observer>
    </template>
  </Panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { showErrorMessage, showSuccessMessage } from '@/notification-utils'

export default {
  name: 'BuyerCampaignSettings',

  title: 'Campaign Settings',

  data() {
    return {
      loading: false,
      restrictDuplicates: 'DoNotRestrict',
      restrictDuplicatesOptions: Object.freeze([
        { value: 'DoNotRestrict', text: 'Do not restrict' },
        { value: 'RestrictByCategory', text: 'Restrict by category' },
        { value: 'RestrictByCampaign', text: 'Restrict by campaign' }
      ])
    }
  },

  computed: {
    ...mapGetters('auth', [
      'buyerCampaignSettings'
    ]),

    currentRestrictDuplicates() {
      return this.buyerCampaignSettings?.restrictDuplicates || 'DoNotRestrict'
    },

    hasChanges() {
      return this.restrictDuplicates !== this.currentRestrictDuplicates
    }
  },

  watch: {
    currentRestrictDuplicates: {
      immediate: true,
      handler(value) {
        this.restrictDuplicates = value
      }
    }
  },

  methods: {
    ...mapActions('auth', [
      'updateBuyerCampaignSettings'
    ]),

    async saveSettings() {
      this.loading = true

      try {
        await this.updateBuyerCampaignSettings({ restrictDuplicates: this.restrictDuplicates })

        showSuccessMessage('Successfully updated campaign settings')
      } catch (error) {
        showErrorMessage(error.response?.data?.title)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
